import React from "react";
import PropTypes from "prop-types";
import "./primary-navbar.css";

const PrimaryNavbar = ({
  logo,
  desktopLinks,
  desktopExtras,
  showMobileRow,
  mobileLinks,
  mobileExtras,
  showMobileAccount,
  mobileAccountBefore,
  mobileAccountContent,
  mobileAccountAfter
}) => {
  const children = [];

  children.push(
    React.createElement("div", { className: "navbar-logo", key: "logo" }, logo)
  );

  children.push(
    React.createElement(
      "div",
      { className: "hidden md:flex items-center gap-4", key: "desktop" },
      React.createElement(
        "div",
        { className: "navbar-links desktop-only" },
        desktopLinks
      ),
      desktopExtras
    )
  );

  if (showMobileRow && mobileLinks) {
    children.push(
      React.createElement(
        "div",
        { className: "navbar-mobile-row md:hidden", key: "mobile-row" },
        React.createElement(
          "div",
          { className: "navbar-links mobile-only" },
          mobileLinks
        ),
        mobileExtras
      )
    );
  }

  if (showMobileAccount && mobileAccountContent) {
    children.push(
      React.createElement(
        "div",
        { className: "navbar-mobile-account md:hidden", key: "mobile-account" },
        mobileAccountBefore,
        mobileAccountContent,
        mobileAccountAfter
      )
    );
  }

  return React.createElement("nav", { className: "navbar" }, ...children);
};

PrimaryNavbar.displayName = "PrimaryNavbar";

PrimaryNavbar.propTypes = {
  logo: PropTypes.node,
  desktopLinks: PropTypes.node,
  desktopExtras: PropTypes.node,
  showMobileRow: PropTypes.bool,
  mobileLinks: PropTypes.node,
  mobileExtras: PropTypes.node,
  showMobileAccount: PropTypes.bool,
  mobileAccountBefore: PropTypes.node,
  mobileAccountContent: PropTypes.node,
  mobileAccountAfter: PropTypes.node
};

PrimaryNavbar.defaultProps = {
  logo: null,
  desktopLinks: null,
  desktopExtras: null,
  showMobileRow: false,
  mobileLinks: null,
  mobileExtras: null,
  showMobileAccount: false,
  mobileAccountBefore: null,
  mobileAccountContent: null,
  mobileAccountAfter: null
};

export default PrimaryNavbar;

